import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LoaderFullPage } from '@alejandro3c/icy-react-ui';

interface PrivateRouteProps {
	allowedRoles: string[];
}

export default function PrivateRoute({ allowedRoles }: PrivateRouteProps) {
	const { user, loading } = useAuth();

	if (loading) return <LoaderFullPage />

	// Si no hay usuario, redirigir al login
	if (!user) return <Navigate to="/login" replace />;

	// Si el usuario no tiene un rol permitido, redirigir a "No autorizado"
	if (!allowedRoles.includes(user.role)) return <Navigate to="/unauthorized" replace />;

	return <Outlet />;
}
